// TODO fix class method not uses this, therefore it is rather util than class method
/* eslint-disable class-methods-use-this */
// TODO fix circular dependencies
/* eslint-disable import/no-cycle */
import isEqual from 'lodash.isequal';
import { convertPropsToObject } from './convert-props-to-object.util';

type Primitives = string | number | boolean;

export interface IDomainPrimitive<T extends Primitives | Date> {
  value: T;
}

type ValueObjectProps<T> = T extends Primitives | Date ? IDomainPrimitive<T> : T;

export abstract class ValueObject<T> {
  protected readonly props: ValueObjectProps<T>;

  protected constructor(props: ValueObjectProps<T>) {
    this.validate(props);
    this.props = props;
  }

  protected abstract validate(props: ValueObjectProps<T>): void;

  public static isValueObject(obj: unknown): obj is ValueObject<unknown> {
    return obj instanceof ValueObject;
  }

  /**
   *  Check if two Value Objects are equal. Checks structural equality.
   * @param vo ValueObject
   */
  public equals(vo?: ValueObject<T>): boolean {
    if (vo === null || vo === undefined) {
      return false;
    }

    return isEqual(this.getRawProps(), vo.getRawProps());
  }

  /**
   * Get raw props object or value.
   */
  public getRawProps(): T {
    if (this.isDomainPrimitive(this.props)) {
      return this.props.value;
    }

    const propsCopy = convertPropsToObject(this.props);

    return Object.freeze(propsCopy);
  }

  private isDomainPrimitive(obj: unknown): obj is IDomainPrimitive<T & (Primitives | Date)> {
    return !!Object.prototype.hasOwnProperty.call(obj, 'value');
  }
}
